import "./index.js";
import { e as p } from "./CSSMotionList.js";
import "react";
import { K as n } from "./Keyframes.js";
import { i as g } from "./Portal.js";
const i = () => ({
  height: 0,
  opacity: 0
}), e = (o) => {
  const {
    scrollHeight: t
  } = o;
  return {
    height: t,
    opacity: 1
  };
}, u = (o) => ({
  height: o ? o.offsetHeight : 0
}), s = (o, t) => (t == null ? void 0 : t.deadline) === !0 || t.propertyName === "height", y = (o = p) => ({
  motionName: `${o}-motion-collapse`,
  onAppearStart: i,
  onEnterStart: i,
  onAppearActive: e,
  onEnterActive: e,
  onLeaveStart: u,
  onLeaveActive: i,
  onAppearEnd: s,
  onEnterEnd: s,
  onLeaveEnd: s,
  motionDeadline: 500
}), H = (o, t, r) => r !== void 0 ? r : `${o}-${t}`, R = y, O = new n("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), z = new n("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
}), m = new n("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
}), c = new n("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
}), h = new n("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
}), K = new n("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
}), w = new n("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
}), d = new n("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
}), I = new n("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
}), Z = new n("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
}), C = new n("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
}), $ = new n("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
}), E = {
  zoom: {
    inKeyframes: O,
    outKeyframes: z
  },
  "zoom-big": {
    inKeyframes: m,
    outKeyframes: c
  },
  "zoom-big-fast": {
    inKeyframes: m,
    outKeyframes: c
  },
  "zoom-left": {
    inKeyframes: w,
    outKeyframes: d
  },
  "zoom-right": {
    inKeyframes: I,
    outKeyframes: Z
  },
  "zoom-up": {
    inKeyframes: h,
    outKeyframes: K
  },
  "zoom-down": {
    inKeyframes: C,
    outKeyframes: $
  }
}, B = (o, t) => {
  const {
    antCls: r
  } = o, a = `${r}-${t}`, {
    inKeyframes: f,
    outKeyframes: l
  } = E[t];
  return [g(a, f, l, t === "zoom-big-fast" ? o.motionDurationFast : o.motionDurationMid), {
    [`
        ${a}-enter,
        ${a}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: o.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${a}-leave`]: {
      animationTimingFunction: o.motionEaseInOutCirc
    }
  }];
};
export {
  R as a,
  H as g,
  B as i,
  O as z
};
